<div class="container forbidden-component">

    <div class="row  align-items-center mt-5">
        <div class="col-md-10 offset-md-1"> <div class="forbidden-text">{{'Forbidden.NotAllowedText' | translate}}</div>  </div>
    </div>
</div>